'use strict';

module.exports = footnoteReference;

function footnoteReference(node) {
  return '[^' + node.identifier + ']';
}



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-stringify/lib/visitors/footnote-reference.js
// module id = 966
// module chunks = 95715928098905 168707334958949